import { useEffect } from 'react';
import { fetchAssets } from '@store/country-management';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@mui/styles";
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	rootFirstSelect: {
		padding: "10px 12px"
	},
	rootSecondSelect: {
		padding: "10px 80px"
	}
}));


export const CountryList = (props) => {
	const classes = useStyles();
	const { status, countries } = useSelector((state) => state.giftCountryList);
	const dispatch = useDispatch();
	const { value, onChange, width, disabled, variant, label, background, compactView } = props;

	useEffect(() => {
		dispatch(fetchAssets());
	}, [dispatch]);

	useEffect(() => {
		if (status === 'OK') {
			onChange(!value ? countries[0].shortName : value);
		}
	}, [status]); // eslint-disable-line react-hooks/exhaustive-deps

	const changeHandler = (e) => {
		if (e && e.target && e.target.value) {
			onChange(e.target.value);
		}
	};

	return (
		<FormControl variant={variant} sx={{ width: width ? width : '100%' }}>
			{label && <InputLabel id="demo-simple-select-label">{label}</InputLabel>}
			<Select
				onChange={changeHandler}
				placeholder="Select Country"
				value={countries.length > 0 ? value : ''}
				label={label}
				disabled={disabled}
				sx={{ background: background }}
				classes={{ select: compactView ? classes.rootFirstSelect : '' }}
			>
				{countries.map(({ shortName, fullName }) => (
					<MenuItem value={shortName} key={`option-id-${shortName}`}>
						{fullName}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
